import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/__auth/dashboard/')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
